import { useState } from "react";
import { AppContext } from "./AppContext";

const AppProvider = ({ children }) => {
  // const [darkTheme, setDarkTheme] = useState(true);

  const [darkTheme, setDarkTheme] = useState(true);

  const value = {
    darkTheme,
    setDarkTheme,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppProvider;